import type {
  EditPortfolioCommandData,
  SubPortfolioEdit,
} from '@festina/unitlink-general-types/unitlink'
import { typeUtils } from '@festina-life/core'
import { FormikFieldArray } from '@festina-life/ui/formikForms'

import { SubPortfolioEditFields } from './SubPortfolioEditFields'

const validateKey = typeUtils.createValidator<EditPortfolioCommandData>()

// We don't generate EditPortfolioCommandData outright because we must show a Select for the subPortfolioKey,
// and to pre-fill the form with the corresponding SubPortfolio on-select, as otherwise the command is unusable.
// Not sending a field means it is cleared from the data model, unlike cover amends (confirmed by @jlj.)
export const EditPortfolioCommandDataFields = () => (
  // The _id field of the inherited PortfolioCommandData is deliberately omitted.
  // The idempotencyKey, priority, processId and validationOverrides from the inherited CommandData are also omitted.
  // These might make sense, but until they are requested to be present, they would only be unnecessary noise.
  <FormikFieldArray
    name={validateKey('subPortfolioEdits')}
    // @beta translations are omitted because this is a raw command and all other generated fields are untranslated
    label="Sub portfolio edits"
    elementLabel="Sub portfolio edit"
    elementInitializer={() =>
      ({
        _type: 'SubPortfolioEdit',
        editType: 'update', // updates are the only thing that exist for now, so we might as well pre-set it
      }) satisfies SubPortfolioEdit
    }
    ChildElement={SubPortfolioEditFields}
  />
)
